<h2 #uuuuu nxHeadline="section" class="section-title">
  {{ "details1.aboutProperty" | translate }}
</h2>
<form [formGroup]="parentForm" style="margin-bottom: 20px">
  <ng-container>
    <qbe-panel-component #mypanel>
      <div
        nxRow
        class="inner-element"
        style="border-bottom: 1px solid #cfe9ee; border-top: 0px; margin: 0px !important; max-width: 1120px;"
      >
        <!-- *ngIf="parentForm.controls.propertyCategory.value != '2'"> -->
        <div nxCol="12, 12, 7" class="inner-element-left">
          <div class="inner-element-left-title">
            {{ "details1.propertyType" | translate }}
          </div>
        </div>
        <div nxCol="12, 12, 5" class="inner-element-right font-neo">
          <nx-formfield [label]="'details1.type' | translate">
            <nx-dropdown
              [valueFormatter]="toText"
              formControlName="propertySubcategory"
              [subcategory]="
                (sharedService.$propertyCategories | async)
                  ?.propertySubcategories
              "
            >
              <nx-dropdown-item
                *ngFor="
                  let category of (sharedService.$propertyCategories | async)
                    ?.propertySubcategories
                    | filterSubcategoryByForId : parentForm
                "
                [value]="category.value"
                (click)="
                  mapTrackService.mapTrackPropertySubCategories(category.value)
                "
              >
                {{ category.label }}
              </nx-dropdown-item>
            </nx-dropdown>
          </nx-formfield>
        </div>
      </div>
      <div nxRow class="outer-top-element">
        <div nxCol="12, 12, 7" class="outer-top-element-left">
          <div class="outer-top-element-left-title">
            {{ "details1.address" | translate }}
          </div>

          <qbe-illustration
            name="illuPinOnMap"
            class="outer-top-element-left-illustration"
          ></qbe-illustration>
        </div>
        <div nxCol="12, 12, 5" class="inner-element-right font-neo">
          <nx-formfield [label]="'details1.postCode' | translate">
            <nx-dropdown
              [valueFormatter]="toText"
              formControlName="postCode"
              [showFilter]="true"
              [codes]="{
                postCodes: (sharedService.$propertyCategories | async)
                  ?.postCodes
              }"
              [filterPlaceholder]="'details1.postCode' | translate"
              (blur)="
                setDigitalDataPostCode(parentForm.controls.postCode.value)
              "
            >
              <nx-dropdown-item
                *ngFor="
                  let code of (sharedService.$propertyCategories | async)
                    ?.postCodes
                "
                [value]="code.value"
                (click)="
                  trackService.pushEventTracking('user.postCode', code.value)
                "
                (click)="setCity(code.value, code.cities[0].label)"
              >
                {{ code.value }}
              </nx-dropdown-item>
            </nx-dropdown>
          </nx-formfield>
          <nx-formfield [label]="'details1.city' | translate">
            <nx-dropdown
              [valueFormatter]="toText"
              formControlName="cityName"
              [showFilter]="false"
            >
              <nx-dropdown-item
                *ngFor="
                  let city of (sharedService.$propertyCategories | async)
                    ?.postCodes | filterCitiesByPostCode : parentForm
                "
                [value]="city.label"
                (click)="
                  trackService.addAttribute('propertyDetails.city', city.label)
                "
                (click)="
                  setCity(parentForm.controls.postCode.value, city.label)
                "
              >
                {{ city.label }}
              </nx-dropdown-item>
            </nx-dropdown>
          </nx-formfield>
          <div nxRow>
            <div nxCol="12,12,12,12">
              <nx-formfield
                [label]="'details1.streetAndNumber' | translate"
                class="inner-element-right-item"
              >
                <input
                  required
                  nxInput
                  formControlName="street"
                  maxlength="80"
                  class="casefree"
                  pattern="[а-яА-ЯЁёIVX0-9-$&+,:;=?@#|^'<>.^*()%!№_-~\/\\[\]\x22 ]*"
                  (change)="
                    trackService.addAttribute(
                      'propertyDetails.street',
                      parentForm.controls?.street.value
                    )
                  "
                  (change)="
                    this.trackService.checkErrors(
                      parentForm.controls?.street,
                      'Property address'
                    )
                  "
                />
              </nx-formfield>
            </div>

          </div>
          <div nxRow>
            <div nxCol="12,12,6,6">
              <nx-formfield
              [label]="'details1.block' | translate"
              class="inner-element-right-item"
            >
              <input
                required
                nxInput
                formControlName="block"
                maxlength="20"
                class="casefree"
                pattern="[а-яА-ЯЁёIVX0-9-$&+,:;=?@#|^'<>.^*()%!№_-~\/\\[\]\x22 ]*"
                (change)="
                  trackService.addAttribute(
                    'propertyDetails.street',
                    parentForm.controls?.street.value
                  )
                "
                (change)="this.trackService.checkErrors( parentForm.controls?.street, 'Property address')"
                (change)="validateBlockStreet('block')"
              />
            </nx-formfield>
            </div>

          <div nxCol="12,12,6,6">
            <nx-formfield
              [label]="'details1.streetNumber' | translate"
              class="inner-element-right-item"
            >
              <input
                required
                nxInput
                formControlName="streetNumber"
                maxlength="20"
                class="casefree"
                pattern="[а-яА-ЯЁёIVX0-9-$&+,:;=?@#|^'<>.^*()%!№_-~\/\\[\]\x22 ]*"
                (change)="
                  trackService.addAttribute(
                    'propertyDetails.street',
                    parentForm.controls?.street.value
                  )
                "
                (change)="this.trackService.checkErrors( parentForm.controls?.street, 'Property address')"
                (change)="validateBlockStreet('streetNumber')"
              />
            </nx-formfield>
          </div>
        </div>
        <div nxRow>
          <div nxCol="12,12,4,4">
            <nx-formfield
            [label]="'details1.entrance' | translate"
            class="inner-element-right-item"
          >
            <input
              required
              nxInput
              formControlName="entrance"
              maxlength="8"
              class="casefree"
              pattern="[а-яА-ЯЁёIVX0-9-$&+,:;=?@#|^'<>.^*()%!№_-~\/\\[\]\x22 ]*"
              (change)="
                trackService.addAttribute(
                  'propertyDetails.street',
                  parentForm.controls?.street.value
                )
              "
              (change)="this.trackService.checkErrors( parentForm.controls?.street, 'Property address')"

            />
          </nx-formfield>
          </div>
          <div nxCol="12,12,4,4">
            <nx-formfield
            [label]="'details1.floor' | translate"
            class="inner-element-right-item"
          >
            <input
              required
              nxInput
              formControlName="floor"
              maxlength="8"
              class="casefree"
              pattern="[а-яА-ЯЁёIVX0-9-$&+,:;=?@#|^'<>.^*()%!№_-~\/\\[\]\x22 ]*"
              (change)="
                trackService.addAttribute(
                  'propertyDetails.street',
                  parentForm.controls?.street.value
                )
              "
              (change)="this.trackService.checkErrors( parentForm.controls?.street, 'Property address')"

            />
          </nx-formfield>
          </div>
          <div nxCol="12,12,4,4">
            <nx-formfield
            [label]="'details1.apartment' | translate"
            class="inner-element-right-item"
          >
            <input
              required
              nxInput
              formControlName="apartment"
              maxlength="8"
              class="casefree"
              pattern="[а-яА-ЯЁёIVX0-9-$&+,:;=?@#|^'<>.^*()%!№_-~\/\\[\]\x22 ]*"
              (change)="
                trackService.addAttribute(
                  'propertyDetails.street',
                  parentForm.controls?.street.value
                )
              "
              (change)="this.trackService.checkErrors( parentForm.controls?.street, 'Property address')"

            />
          </nx-formfield>
          </div>
        </div>

        <ng-container *ngIf="gmapsSelectAddress && this.formService.showGoogleAddress">
          <nx-radio-group formControlName="fullAddress">
        <table nxTable class="table-hover">
          <thead>
            <tr>
              <th nxHeaderCell style="text-align: left">{{'details1.city2' | translate}} <br> {{'details1.city3' | translate}}</th>
              <th nxHeaderCell>{{'details1.street' | translate}} <br> {{'details1.street2' | translate}}</th>
              <th nxHeaderCell>{{'details1.street3' | translate}} <br> №</th>
              <th nxHeaderCell></th>

            </tr>
          </thead>
          <tbody>
              <tr nxTableRow *ngFor="let address of gmapsSelectAddress; let i = index" >

                <td nxTableCell style="text-align: left">
                  {{address.settlement}}
                </td>
                <td nxTableCell>{{address.streetName}}</td>

                <!-- START PHONE WITHOUT ANY ERROR -->

                <td nxTableCell>
                  {{address.streetNo}}
                </td>
                <td nxTableCell>

                  <nx-radio [value]="address"
                  [nxChecked]="isCheckedAddress(address)" (click)="setAddress(address)"></nx-radio>
                </td>

              </tr>

          </tbody>
        </table>
          </nx-radio-group>
      </ng-container>
        </div>
      </div>
      <div nxRow class="inner-element">
        <div nxCol="12, 12, 7" class="inner-element-left">
          <div class="inner-element-left-title">
            {{ "details1.propertyPurpose" | translate }}
          </div>
        </div>
        <div nxCol="12, 12, 5" class="inner-element-right">
          <nx-formfield [label]="'details1.purpose' | translate">
            <nx-dropdown
              [valueFormatter]="toText"
              formControlName="purpose"
              (blur)="setDigitalDataPurpose(parentForm.controls.purpose.value)"
            >
              <nx-dropdown-item
                *ngFor="let usage of sharedService.$usage | async"
                [value]="usage.value"
                (click)="mapTrackService.mapTrackPropertyPurpose(usage.value)"
              >
                {{ usage.label }}
              </nx-dropdown-item>
            </nx-dropdown>
          </nx-formfield>
        </div>
      </div>
      <div nxRow class="inner-element">
        <div nxCol="12, 12, 7" class="inner-element-left">
          <div class="inner-element-left-title">
            {{ "details1.propertyYear" | translate }}
          </div>
        </div>
        <div nxCol="12, 12, 5" class="inner-element-right">
          <nx-formfield label="{{ 'details1.year' | translate }}">
            <input
              required
              nxDatefield
              (change)="
                this.trackService.checkErrors(
                  parentForm.controls.yearOfConstruction,
                  'Property year of contruction'
                )
              "
              [parseFormat]="parseFormat"
              displayFormat="YYYY"
              [min]="minDate"
              [max]="maxDate"
              maxlength="4"
              minlength="4"
              pattern="^[0-9]{4}$"
              nxInput
              [datepicker]="year"
              (dateInput)="
                setDigitalDataConstructionYear(
                  this.parentForm.controls.yearOfConstruction.value
                )
              "
              formControlName="yearOfConstruction"
            />
            <nx-datepicker-toggle
              [for]="year"
              nxFormfieldSuffix
            ></nx-datepicker-toggle>
            <nx-datepicker
              [startAt]="startAt"
              startView="multi-year"
              #year
              (yearSelected)="chosenYearHandler($event, year)"
              (yearSelected)="
                this.trackService.checkErrors(
                  parentForm.controls.yearOfConstruction,
                  'Property year of contruction'
                )
              "
            ></nx-datepicker>
            <span nxFormfieldHint>YYYY</span>
          </nx-formfield>
        </div>
      </div>
    </qbe-panel-component>
  </ng-container>
</form>

<div class="error-message-address">
  <nx-message-banner
  *ngIf="sharedService.errorMessageFindAddress$ | async"
  context="error"
  closable="true"
  (close)="sharedService.errorMessageFindAddress$.next(false)"
  class="nx-margin-bottom-xs"
>

{{ 'details1.errorMessageFindAddress' | translate  }}
</nx-message-banner>


</div>
